<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:mb-4">
            <base-ro-input :label="$t('locations.cif')" :data="form.cif"/>
          </div>
          <div class="lg:mb-4">
            <base-ro-input :label="$t('locations.locationName')" :data="form.location"/>
          </div>
          <div class="lg:mb-4">
            <base-ro-input :label="$t('locations.certificate')" :data="form.certificate"/>
          </div>
          <div class="lg:mb-4">
            <base-ro-input :label="$t('locations.user')" :data="form.user"/>
          </div>
          <div class="lg:mb-4">
            <base-ro-input :label="$t('locations.access')" :data="form.access"/>
          </div>
          <div class="lg:mb-4">
            <base-ro-input :label="$t('locations.activated')" :data="form.activated"/>
          </div>
          <div class="lg:mb-4">
            <base-ro-input :label="$t('locations.connection')" :data="form.connection"/>
          </div>
        </el-form>
    </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions" />
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getSedesByEmpresa } from '@/services/app/getSedesByEmpresa'
import { getCompany } from '@/services/companies/getCompany'

import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayout
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      header: {
        title: 'SEDES DETALLE',
        icon: 'companies',
        breadcrumb: {},
        nav: [],
        url: 'companies/locations'
      },
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      form: {
        id: 0,
        cif: '',
        location: '',
        activated: false,
        access: '',
        certificate: '',
        connection: false,
        user: ''
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        company: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        location: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: function () {

  },
  mounted: async function () {
    const companyId = this.$route.params.id
    const company = await this.downloadCompanyData(companyId)
    const location = await this.downloadData(companyId)
    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies/locations', name: this.$i18n.t('app.companies') })
    breadcrumbs.push({ path: '', name: company.data[0].name })
    breadcrumbs.push({ path: '', name: location.data[0].cif })
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    watchFormHandler: function ({ certificate, send_alerts, automatic_download }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (automatic_download !== undefined) {
        this.form.automatic_download = !!automatic_download
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.isProcessing = true
      setTimeout(() => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.doFeedback('Error al procesar los datos, revise la información', 'success')
            this.isProcessing = false
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
            this.isProcessing = false
            return false
          }
        })
      }, 1000)
    },
    goBack: function () {
      this.$router.push({ name: 'companies/locations' })
    },
    downloadCompanyData: async function (companyId) {
      const company = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = { IdCifEmpresa: companyId }
        const company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(company.msgError + ' [Código de error: ' + company.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return company
    },
    downloadData: async function (companyId) {
      let location = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          with: 'user,product'
        }
        location = await getSedesByEmpresa(companyId, params)
        if (location.blnError === true) {
          this.doFeedback(location.msgError + ' [Código de error: ' + location.codError + ']')
        } else {
          this.setLocation(location.data[0])
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return location
    },
    setLocation: function (location) {
      this.form.id = location.id
      this.form.cif = location.cif
      this.form.location = location.location
      this.form.activated = location.activated
      this.form.access = location.access
      this.form.certificate = location.certificate
      this.form.connection = location.connection
      this.form.user = location.user
    }
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
